define('views/modules/help/tutorial/tutorial-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/menu/menu-action',
    // templates
    'text!templates/modules/help/tutorial/tutorial-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    User,
    // views
    VMenuAction,
    // templates
    TTutorialContent
) {

    var VContactContent = Backbone.View.extend({
        template: TTutorialContent,

        events: {
            "click .item-section": "onTutorialClick"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                profile: opt.profile,
                group: opt.group,
                url: opt.url
            });

            var view = this.view = {

            };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            return this;
        },

        /////////////
        // actions //
        /////////////
        onTutorialClick: function(e) {
            e.preventDefault();
            window.open(Backbone.$(e.currentTarget).attr('data-link'), '_system');
        },

        onSendAction: function() {

        },

        ////////////
        // events //
        ////////////

    });

    return VContactContent;

});

